import TextField from '@mui/material/TextField'
import { Text } from '../1elements'

const fieldSx = theme => ({
    backgroundColor: theme.palette.quaternary.main,
    width: '91%',
    '& .MuiTextField-root': {
      marginTop: 0,
    },
    '& .MuiInputBase-input': {
      padding: '5px 13px',
      boxShadow: 'none',
      '&:focus': {
        boxShadow: `${theme.boxShadow} !important`
      },
      '&:hover': {
        boxShadow: `${theme.boxShadow} !important`
      }
    },
    '& .MuiInputBase-multiline': {
      padding: 0
    },
    '& .MuiOutlinedInput-root': {
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      border: 'none'
    }
})

const DescriptionField= ({ disabled, label, hint, required, validation, value, onChange, rows, className, InputProps, name, error, helperText }) => {
  const validationMessage = () => {
    return validation || '' // spacer
  }

  const updateValue = (e) => {
    onChange(e.target.value)
  }

  return (
    <div className={className}>
      <Text type='fieldLabel'>{label}{required && <span className='requiredAsterisk'>*</span>} <span>{hint && `(${hint})`}</span></Text>
      {
                value
                  ? (
                    <TextField
                      disabled={disabled} value={value} variant='outlined' error={error} helperText={helperText} name={name} id={name}
                      multiline={Boolean(rows)} onChange={updateValue} InputProps={InputProps} sx={fieldSx}
                    />
                    )
                  : (
                    <TextField
                      disabled={disabled} value={value} variant='outlined' error={Boolean(validation)} helperText={validationMessage()}
                      multiline={Boolean(rows)} onChange={updateValue} InputProps={InputProps} sx={fieldSx}
                    />
                    )
            }

    </div>
  )
}

export default DescriptionField
